import React from 'react';
import { arrayOf, object, shape, string } from 'prop-types';

import Snackbar from './Snackbar';
import styles from './styles.scss';

const SnackbarBase = ({ snackbars }) => (
  <div className={styles.snackbarContainer}>
    {
      snackbars.map((snackbar) => (
        <Snackbar
          key={snackbar.id}
          {...snackbar}
        />
      ))
    }
  </div>
);

const SnackbarProps = {
  id: string.isRequired,
  message: string.isRequired,
  options: object,
};

SnackbarBase.propTypes = {
  snackbars: arrayOf(shape(SnackbarProps)),
};

export default SnackbarBase;
